import { Slider as SliderPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '../../utils/cn'

/** Radix slider in the design system's look; the aria naming props land on the thumb, which carries role="slider". */
function Slider({
  className,
  value,
  defaultValue,
  min = 0,
  max = 100,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
  'aria-valuetext': ariaValueText,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const thumbCount = (value ?? defaultValue ?? [min]).length

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      value={value}
      defaultValue={defaultValue}
      min={min}
      max={max}
      className={cn(
        'relative flex h-6 w-full touch-none items-center select-none data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className="bg-input relative h-1.5 w-full grow overflow-hidden rounded-full"
      >
        <SliderPrimitive.Range data-slot="slider-range" className="bg-brand-600 absolute h-full" />
      </SliderPrimitive.Track>
      {Array.from({ length: thumbCount }, (_, index) => (
        <SliderPrimitive.Thumb
          key={index}
          data-slot="slider-thumb"
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          aria-describedby={ariaDescribedBy}
          aria-valuetext={ariaValueText}
          className="border-ink-900 bg-surface hover:ring-ring/30 focus-visible:ring-ring/50 block size-5 shrink-0 rounded-full border-2 shadow-sm transition-[box-shadow] outline-none hover:ring-4 focus-visible:ring-[3px] data-[disabled]:pointer-events-none max-sm:size-6"
        />
      ))}
    </SliderPrimitive.Root>
  )
}

export { Slider }
